import React from 'react';
import { motion } from 'framer-motion';

const W = 560; 
const H = 180; 

const Mat3D = () => {
  const matSrc = "/images/mat-top-cutout-cropped.png";

  return (
    <div className="relative preserve-3d" style={{ width: W, height: H, transformStyle: "preserve-3d" }}>
      {/* Warm animated glow around the cutout mat shape */}
      <motion.img
        src={matSrc}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-contain"
        animate={{
          filter: [
            "brightness(1.25) saturate(1.08) drop-shadow(0 0 10px rgba(240,178,74,0.45)) drop-shadow(0 0 26px rgba(240,178,74,0.30))",
            "brightness(1.35) saturate(1.12) drop-shadow(0 0 14px rgba(240,178,74,0.65)) drop-shadow(0 0 40px rgba(240,178,74,0.45))",
            "brightness(1.25) saturate(1.08) drop-shadow(0 0 10px rgba(240,178,74,0.45)) drop-shadow(0 0 26px rgba(240,178,74,0.30))",
          ],
        }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Actual mat cutout (no rectangular slab behind it) */}
      <img
        src={matSrc}
        alt="SaniQ mat"
        className="relative z-10 h-full w-full object-contain"
        draggable={false}
      />

      {/* Floor warm bleed */}
      <motion.div
        className="absolute top-4 left-4 bg-[#f0b24a]/35 blur-[80px] rounded-full pointer-events-none"
        animate={{ opacity: [0.6, 0.9, 0.6] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        style={{ width: W - 40, height: H - 80, transform: "translateZ(-80px)" }}
      />
      <div
        className="absolute top-10 left-10 bg-black/80 blur-[40px] rounded-full pointer-events-none"
        style={{ width: W - 120, height: H - 90, transform: "translateZ(-79px)" }}
      />
    </div>
  );
};

export default Mat3D;